import {
    PERFORMANCE_BY_SKU_SUCCESS,
    PERFORMANCE_BY_SKU_LOADING,
  } from '../actions/PerformanceBySKUAction';
  
  const initialState = {
    performanceBySKUData: [],
    isLoading: true
  };
  
  const PerformanceBySKUReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case PERFORMANCE_BY_SKU_SUCCESS:
        return { ...state, performanceBySKUData: action.data, isLoading: false };
      case PERFORMANCE_BY_SKU_LOADING:
        return { ...state, isLoading: action.isLoading };
      default:
        return state;
    }
  };
  
  export default PerformanceBySKUReducer;
  